import { t } from 'i18next';

import { Card, CardHeader, CardImage } from '@/components/atoms/Card';
import { Spinner } from '@/components/atoms/Spinner';
import { EmptyState } from '@/components/molecules/EmptyState';
import type { Image } from '@/components/organisms/ImageViewer';

import ViewButton from './ViewButton';

import styles from '../CageWelfareDashboard.module.scss';

interface DetectionsCardProps {
    images?: Image[];
    detectionsLoading: boolean;
    onView: () => void;
}

/** The pen's latest wound detection image. */
export default function DetectionsCard(props: DetectionsCardProps) {
    const { images, detectionsLoading, onView } = props;
    const lastImage = images?.at(-1);

    return (
        <Card
            padding="lg"
            header={
                <CardHeader
                    title={t('common.labels.detections')}
                    level="h2"
                    size="card"
                    actions={
                        <ViewButton
                            trackingId="welfare_dashboard_view_detections"
                            onClick={onView}
                        />
                    }
                />
            }>
            <div className={styles.smallBoxMaxWidth}>
                {!detectionsLoading &&
                    (lastImage ? (
                        <CardImage src={lastImage.path} alt={t('atoms.detectionImage.alt')} />
                    ) : (
                        <EmptyState title={t('common.labels.atTheMomentWeDo')} />
                    ))}
                {detectionsLoading && <Spinner size="lg" />}
            </div>
        </Card>
    );
}
